import { render } from "./textarea.vue?vue&type=template&id=c259f9f2&lang=pug"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/textarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c259f9f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c259f9f2', __exports__)) {
    api.reload('c259f9f2', __exports__)
  }
  
  module.hot.accept("./textarea.vue?vue&type=template&id=c259f9f2&lang=pug", () => {
    api.rerender('c259f9f2', render)
  })

}


export default __exports__